  Currency.format = 'money_format';

  var shopCurrency = 'USD';
  if(shopCurrency != 'USD'){
    window.location = window.location.href + '?currency='+shopCurrency;
  }
  
  Currency.moneyFormats[shopCurrency].money_with_currency_format = "${{amount}} USD";
  Currency.moneyFormats[shopCurrency].money_format = "${{amount}}";

  var cookieCurrency = Currency.cookie.read();

  $('span.money span.money').each(function() {
    $(this).parent('span.money').removeClass('money');
  });

  $('span.money').each(function() {
    $(this).attr('data-currency-USD', jQuery(this).html());
  });

  if (cookieCurrency == null || cookieCurrency == shopCurrency) {
    Currency.currentCurrency = shopCurrency;
  } else {
    var flag = 0;
    $('#currencies li').each(function(){
      if(cookieCurrency == $(this).data('currency')){
        flag = 1;
      }
    });
    if(flag == 0 ){
      cookieCurrency = shopCurrency;
    }
    Currency.currentCurrency = cookieCurrency;
    $('#currencies li').removeClass('active');
    $('#currencies li[data-currency=' + Currency.currentCurrency + ']').addClass('active');
    var curItem = $('#currencies .active').html();
    $('summary[data-currency-label]').html(curItem);
    Currency.convertAll(shopCurrency, cookieCurrency);
  };
       
  $('#currencies li').on('click', function(e) {
    e.preventDefault();
        
    if($(this).hasClass('active')) return false;
    
    var cur = $(this).attr('data-currency');
    $('#currencies li').removeClass('active');
        
    $('#currencies li[data-currency="'+cur+'"]').addClass('active');
        
    if($('summary.dropdown-label').length && $('summary.dropdown-label').is(':visible')) {
      var item = $(this).html();
      $('summary.dropdown-label').html(item);
    };

    $('.currency-selector details[open]').removeAttr('open');
    
    cur != Currency.currentCurrency && Currency.convertAll(Currency.currentCurrency, cur);
  });